module.exports = __webpack_public_path__ + "static/img/中间.29b54a1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/banner2/中间.png
// module id = r3Me
// module chunks = 1